import { SkuDemand } from 'types/sku-demand';
import { SkuLocation } from 'types/sku-location';

import { Defect } from './defects';
import { SkuModelReference } from './sku-model-reference';
import { FittingType } from './spare-part-fittings';

const NEW = 'new';
const SECOND_HAND = 'second_hand';

export type SparePartType = typeof NEW | typeof SECOND_HAND;

export type BaseSparePart = {
  id: number;
  unique_id: string;
  location: SkuLocation;
  status:
    | 'ordered'
    | 'instock'
    | 'reserved'
    | 'waiting_for_packing'
    | 'packed'
    | 'received_tech'
    | 'return_to_warehouse'
    | 'lost'
    | 'deployment_adjustment';
  thumbnail?: string;
  demand_item?: number;
  demand?: SkuDemand;
};

export type SparePart = BaseSparePart & {
  aswo_order_delay: number;
  sku: number;
  designation: string;
  reference: string;
  supplier_name: string;
  canonical_reference: SkuModelReference;
  installation_date?: string; // ISO Date string; Visit timeslot beginning
  is_second_hand: boolean;
  is_boarded_stock: boolean;
  defects: Defect[];
  is_defective: boolean;
  type?: SparePartType;
};

export interface SparePartWithFittingType extends SparePart {
  fitting_type?: FittingType;
}

export const buildSkuReference = (sku: SparePart): string => {
  return sku.supplier_name + '_' + sku.reference;
};

export const getDesignation = (sku: BaseSparePart): string => {
  return (sku as SparePart).designation;
};
